import { Box, Typography } from "@mui/material";
import SourceIcon from "./sourceIcon";

const UpdateData = ({ log }) => {
  return (
    <Box dir="rtl">
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start", // Changed to flex-start for RTL
          alignItems: "flex-start",
        }}
      >
        <Typography
          variant="body1"
          sx={{ textAlign: "right", whiteSpace: "nowrap" }}
        >
          {log.details.description ? (
            <>
              {log.details.description}{" "}
              {log.details.prioritySubformData?.line && (
                <Typography variant="body1" component="span">
                  במסך <strong>{log.details.prioritySubformData.screen}</strong>
                  {" שורה "}
                  <strong>{log.details.prioritySubformData.line}</strong>
                </Typography>
              )}
            </>
          ) : (
            <>שינוי במסך {log.details.prioritySubformData.screen}</>
          )}
        </Typography>

        <Box sx={{ ml: 2 }}>
          {" "}
          {/* Changed from mr to ml */}
          <SourceIcon source={log.source} />
        </Box>
      </Box>

      <Box sx={{ mt: 1 }}>
        {log.details.changedFields.map((field, ind) => (
          <Box key={ind} sx={{ mb: 0.5 }}>
            {field.oldValue ? (
              <Box sx={{ width: "100%", mt: 0.5, pr: 2 }}>
                <Typography
                  variant="body2"
                  sx={{
                    display: "flex",
                    gap: "4px", // Add space between flex items
                    alignItems: "center", // Align items vertically
                  }}
                >
                  שדה
                  <strong>{field.fieldName}</strong>
                  {" עודכן מ: "}
                  <span style={{ direction: "ltr", display: "inline-block" }}>
                    {field.oldValue}
                  </span>
                  {" ל: "}
                  <span style={{ direction: "ltr", display: "inline-block" }}>
                    {field.newValue}
                  </span>
                </Typography>
              </Box>
            ) : (
              <Typography
                variant="body2"
                sx={{
                  textAlign: "right",
                  whiteSpace: "nowrap",
                }}
              >
                שדה <strong>{field.fieldName}</strong> אותחל בערך:{" "}
                <span style={{ direction: "ltr", display: "inline-block" }}>
                  {field.newValue}
                </span>
              </Typography>
            )}
          </Box>
        ))}
        <Box sx={{ mt: 1, display: "flex", justifyContent: "flex-start" }}>
          <Typography variant="body2" sx={{ direction: "rtl" }}>
            {log.details.userLogin} :על ידי
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default UpdateData;
